export default "__VITE_ASSET__DC$cA45G__"